import React, { useEffect } from "react";
import styled from "styled-components";
import { Table } from "./Table";
import Calendar from "components/foundation/Calendar";
import Modal from "components/foundation/Modal/Modal";
import Button from "components/foundation/Button";
import { RangeDateType } from "models/DateTypes";

interface TableDatePickerMobileProps {
  children?: React.ReactNode;
  isSelected?: boolean;
  onDateRangeSelected?: (date: RangeDateType) => void;
  onClickReset?: boolean;
}
const TableDatePickerMobile = ({
  children,
  isSelected,
  onDateRangeSelected,
  onClickReset,
}: TableDatePickerMobileProps) => {
  const [dateRange, setDateRange] = React.useState<RangeDateType>({
    start: new Date(),
    end: new Date(),
  });

  const handleSelectDate = () => {
    onDateRangeSelected?.(dateRange);
  };

  useEffect(() => {
    if (onClickReset !== undefined) {
      setDateRange({
        start: new Date(),
        end: new Date(),
      });
    }
  }, [onClickReset]);

  return (
    <Modal.Root>
      <Modal.Trigger asChild>
        <TableDatePickerMobileLayout
          variant={isSelected ? "primary" : "tertiary"}
          size="small"
        >
          {children}
        </TableDatePickerMobileLayout>
      </Modal.Trigger>
      <Modal.Layout
        style={{
          padding: "2rem",
        }}
      >
        <Calendar
          type="range"
          rangeDate={dateRange}
          style={{
            boxShadow: "none",
            padding: "0rem",
            border: "none",
          }}
          onChangeRangeDate={(rangeDate) => {
            setDateRange(rangeDate);
          }}
        />
        <ModalFooter>
          <Modal.Close asChild>
            <Button variant="ghost" size="large">
              취소
            </Button>
          </Modal.Close>
          <Modal.Close asChild>
            <Button size="large" onClick={handleSelectDate}>
              선택 완료
            </Button>
          </Modal.Close>
        </ModalFooter>
      </Modal.Layout>
    </Modal.Root>
  );
};

export default TableDatePickerMobile;

const TableDatePickerMobileLayout = styled(Table.Button)`
  display: flex;
  gap: 0.4rem;
  align-items: center;
  padding: 0.4rem 1rem;
`;

const ModalFooter = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2.4rem;

  > button {
    flex: 1;
  }
`;
